import { defer, Observable, ObservableInput, throwError } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { expireSession } from '../pages/Login/useLogin';

export interface ResponseError extends Error {
  response: Response;
}

export type SuccessHandler<T> = (response: Response) => ObservableInput<T>;

export interface RequestOptions<R = any> extends RequestInit {
  success?: SuccessHandler<R>;
}

const defaultSuccess = (response: Response) => {
  const isJSON = response?.headers.get('content-type')?.indexOf('application/json');
  return isJSON != null && isJSON >= 0 ? response.json() : response.text();
};

const responseHandler =
  <R>(path = '', success: SuccessHandler<R> = defaultSuccess) =>
  (response: Response) => {
    if (response.ok) return success(response);

    const error: ResponseError = Object.assign(new Error(`Request ${response.status} error from ${path}`), {
      response,
    });

    /** force to login when unauthorized error occurs */
    if (response.status === 401 && new URL(response.url).pathname !== '/gateway/auth/users/current') {
      expireSession();
    }

    return throwError(() => error);
  };

export const request = <R>(path = '', options?: RequestOptions<R>): Observable<R> =>
  defer(() =>
    fromFetch<R>(path, {
      ...options,
      selector: responseHandler(path, options?.success),
    })
  );
